<template>
  <div class="footer_box no-select cursor">
    <div class="footer_main flex_between w_1280">
      <div class="flex">
        <div class="footer_logo">
          <img src="@/assets/images/bottomLogo.png" alt="" />
        </div>
        <div class="footer_main_left color_fff" v-if="systemLink.length > 0">
          <div class="main_left_text flex cursor"><img src="@/assets/images/bottomAddress.png" alt="" />
            {{ systemLink[4].value }}
          </div>
          <div class="main_left_text flex cursor"><img src="@/assets/images/bottomPhone.png" alt="" />
            {{ systemLink[5].value }}
          </div>
        </div>
      </div>
      <div class="flex">
        <div class="footer_module_list color_fff">
          <div class="footer_module_link cursor" @click="handleCommand(item.value)" v-for="item in friendList"
            :key="item.code">
            {{ item.name }}
          </div>
        </div>
        <div class="customer_service_img flex_center">
          <img src="@/assets/images/qrCode.png" alt="" />
          <span>微信公众号</span>
        </div>
      </div>


    </div>

    <div class="footer_bottom flex_center w_1280">
      <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer"
        class="footer_bottom_left flex"><img src="@/assets/images/publicSecurityLogo.png" alt="">鲁ICP备19040167号
      </a>
      <div>@2025 版权所有：山东焦易网数字科技股份有限公司</div>
    </div>
  </div>
</template>

<script>
import { userInfo, systemInfo } from "@/utils/api";
export default {
  name: 'BottomBar',
  props: {
    msg: String
  },
  data() {
    return {
      friendList: [],
      systemLink: [],
    };
  },
  mounted() {
    this.getSystemInfo();
  },
  methods: {
    async getSystemInfo() {
      let res = await systemInfo();
      if (res.code == 200) {
        this.friendList = res.data.friendList;
        this.systemLink = res.data.link;
      }
    },

    handleCommand(url) {
      window.open(url, '_blank');
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.footer_box {
  position: relative;
  width: 100%;
  background: #110E5A;
  padding-bottom: 40px;
  z-index: 999;
}

.footer_main {
  padding-top: 95px;
}

.main_left_text {
  font-weight: 600;
  margin-top: 10px;

  img {
    margin-right: 5px;
  }
}

.margin_top_30 {
  padding-top: 30px;
}

.contact_us_title {
  font-size: 14px;
  margin-right: 10px
}

.contact_phone {
  font-size: 26px;
  color: #434343;
  font-weight: 600;
  margin-right: 10px;
}

.footer_logo img {
  width: 180px;
  height: 63px;
  margin-right: 50px;
}

.footer_module_list {
  padding-right: 33px;
  border-right: 1px solid #999999;
}

.footer_module_link {
  margin: 6px 0;
  border-bottom: 1px solid #fff;
}

.customer_service_img {
  width: 80px;
  font-size: 12px;
  line-height: 12px;
  color: #fff;
  padding-left: 33px;
}

.customer_service_img img {
  width: 62px;
  height: 62px;
  margin-right: 11px;
}

.footer_bottom {
  width: 100%;
  //width: 68%;
  border-top: 1px solid #A0A0A0;
  font-size: 17px;
  color: #FFFFFF;
  padding-top: 27px;
  margin-top: 47px;
}

.footer_bottom_left {
  margin-right: 70px;
  color: inherit;
  text-decoration: none;
}

.footer_bottom_left img {
  width: 22px;
  height: 25px;
  margin-right: 5px;
}
</style>